import CheckoutFooter from "./NewDesign/CheckoutHeaderFooter/CheckoutFooter/CheckoutFooter";
import CheckoutHeader from "./NewDesign/CheckoutHeaderFooter/CheckoutHeader/CheckoutHeader";
import { isAndroid, isIOS } from "react-device-detect";

const PaymentOutlinePage = ({isMobile,...props}) => {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const type = params.get("type");
  const isMobileAsQueryParam = params.get("isMobile");
  if(isMobileAsQueryParam){
    isMobile=isMobileAsQueryParam;
  }
    return (
        <>
            <section className="order-info-sec">
                <div className="container">
                    <CheckoutHeader />
                    {props.children}
                   {isMobile ? "" : <CheckoutFooter />}
                </div>
            </section>
        </>
    )
}

export default PaymentOutlinePage;